"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Feb 14 2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../core/utils/index");

var WindowItemSimulation_1 = require("../model/WindowItemSimulation");

var SimulationBigNumberConverter_1 = require("./SimulationBigNumberConverter");

var SimulationStringConverter_1 = require("./SimulationStringConverter");

var WindowItemSimulationConverter_1 = require("./WindowItemSimulationConverter");
/**
 * Default implementation of WindowItemSimulationConverterImpl.
 * @author BPo
 */


var WindowItemSimulationConverterImpl =
/*#__PURE__*/
function (_WindowItemSimulation) {
  _inherits(WindowItemSimulationConverterImpl, _WindowItemSimulation);

  function WindowItemSimulationConverterImpl(simulationBigNumberConverter, simulationStringConverter) {
    var _this;

    _classCallCheck(this, WindowItemSimulationConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSimulationConverterImpl).call(this));
    _this.simulationBigNumberConverter = simulationBigNumberConverter;
    _this.simulationStringConverter = simulationStringConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowItemSimulationConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      var id = index_1.Utils.VOID_ID;

      try {
        id = conversions.documentToClassId(source);
      } catch (ex) {// ignored - try-catch for backward compatibility only
      }

      return new WindowItemSimulation_1.WindowItemSimulation(id === index_1.Utils.VOID_ID ? index_1.Utils.VOID_ID
      /* for backward compatibility only */
      : WindowItemSimulation_1.WindowItemSimulation.schema.id.valueOf(id), WindowItemSimulation_1.WindowItemSimulation.schema.simulationId.valueOf(conversions.toClassReferenceId(source.simulationId)), WindowItemSimulation_1.WindowItemSimulation.schema.originId.valueOf(conversions.toClassReferenceId(source.originId)), WindowItemSimulation_1.WindowItemSimulation.schema.state.valueOfField(source), conversions.asObjectOpt(source, 'regularPrice', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationBigNumberConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'promoPrice', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationBigNumberConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'promoVolume', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationBigNumberConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'posMarginImpactTheoretical', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationBigNumberConverter.toObject(document, conversions);
      }), WindowItemSimulation_1.WindowItemSimulation.schema.posMarginImpactExpected.valueOf(conversions.toBigNumber(source.posMarginImpactExpected)), WindowItemSimulation_1.WindowItemSimulation.schema.posRedemption.valueOf(conversions.toBigNumber(source.posRedemption)), conversions.asObjectOpt(source, 'posMechanics', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationStringConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'vaValue', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationBigNumberConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'promoPurchasePrice', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationBigNumberConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'unitBackDiscount', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationBigNumberConverter.toObject(document, conversions);
      }), WindowItemSimulation_1.WindowItemSimulation.schema.preferredPromoPurchasePrice.valueOf(conversions.toBigNumber(source.preferredPromoPurchasePrice)), WindowItemSimulation_1.WindowItemSimulation.schema.preferredPromoPurchaseStartDate.valueOf(source.preferredPromoPurchaseStartDate ? conversions.toDate(source.preferredPromoPurchaseStartDate) : null), WindowItemSimulation_1.WindowItemSimulation.schema.preferredUnitBackDiscount.valueOf(conversions.toBigNumber(source.preferredUnitBackDiscount)), WindowItemSimulation_1.WindowItemSimulation.schema.preferredSupplierId.valueOf(conversions.toClassReferenceId(source.preferredSupplierId)), WindowItemSimulation_1.WindowItemSimulation.schema.preferredCurrencyId.valueOf(conversions.toClassReferenceId(source.preferredCurrencyId)), WindowItemSimulation_1.WindowItemSimulation.schema.preferredRegularPurchasePrice.valueOf(conversions.toBigNumber(source.preferredRegularPurchasePrice)), WindowItemSimulation_1.WindowItemSimulation.schema.preferredRegularPurchasePriceNett.valueOf(conversions.toBigNumber(source.preferredRegularPurchasePriceNett)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        simulationId: conversions.toDocumentReferenceId(source.simulationId),
        originId: index_1.Utils.isValueMissing(source.originId) ? null : conversions.toDocumentReferenceId(source.originId),
        state: source.state,
        regularPrice: conversions.asObjectOpt(source, 'regularPrice', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationBigNumberConverter.toDocument(object, conversions);
        }),
        promoPrice: conversions.asObjectOpt(source, 'promoPrice', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationBigNumberConverter.toDocument(object, conversions);
        }),
        promoVolume: conversions.asObjectOpt(source, 'promoVolume', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationBigNumberConverter.toDocument(object, conversions);
        }),
        posMarginImpactTheoretical: conversions.asObjectOpt(source, 'posMarginImpactTheoretical', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationBigNumberConverter.toDocument(object, conversions);
        }),
        posMarginImpactExpected: conversions.fromBigNumber(source.posMarginImpactExpected),
        posRedemption: conversions.fromBigNumber(source.posRedemption),
        posMechanics: conversions.asObjectOpt(source, 'posMechanics', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationStringConverter.toDocument(object, conversions);
        }),
        vaValue: conversions.asObjectOpt(source, 'vaValue', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationBigNumberConverter.toDocument(object, conversions);
        }),
        promoPurchasePrice: conversions.asObjectOpt(source, 'promoPurchasePrice', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationBigNumberConverter.toDocument(object, conversions);
        }),
        unitBackDiscount: conversions.asObjectOpt(source, 'unitBackDiscount', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationBigNumberConverter.toDocument(object, conversions);
        }),
        preferredPromoPurchasePrice: conversions.fromBigNumber(source.preferredPromoPurchasePrice),
        preferredPromoPurchaseStartDate: source.preferredPromoPurchaseStartDate ? conversions.fromDate(source.preferredPromoPurchaseStartDate) : null,
        preferredUnitBackDiscount: conversions.fromBigNumber(source.preferredUnitBackDiscount),
        preferredSupplierId: conversions.toDocumentReferenceId(source.preferredSupplierId),
        preferredCurrencyId: conversions.toDocumentReferenceId(source.preferredCurrencyId),
        preferredRegularPurchasePrice: conversions.fromBigNumber(source.preferredRegularPurchasePrice),
        preferredRegularPurchasePriceNett: conversions.fromBigNumber(source.preferredRegularPurchasePriceNett)
      });
      return result;
    }
  }]);

  return WindowItemSimulationConverterImpl;
}(WindowItemSimulationConverter_1.WindowItemSimulationConverter);

WindowItemSimulationConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SimulationBigNumberConverter_1.SimulationBigNumberConverter, SimulationStringConverter_1.SimulationStringConverter])], WindowItemSimulationConverterImpl);
exports.WindowItemSimulationConverterImpl = WindowItemSimulationConverterImpl;